__turbopack_context__.v({
  "backdrop": "TableOfContentsMobile-module-scss-module__ASJpFW__backdrop",
  "bodyExtraScroll": "TableOfContentsMobile-module-scss-module__ASJpFW__bodyExtraScroll",
  "contained": "TableOfContentsMobile-module-scss-module__ASJpFW__contained",
  "content": "TableOfContentsMobile-module-scss-module__ASJpFW__content",
  "expandIcon": "TableOfContentsMobile-module-scss-module__ASJpFW__expandIcon",
  "heading": "TableOfContentsMobile-module-scss-module__ASJpFW__heading",
  "listIcon": "TableOfContentsMobile-module-scss-module__ASJpFW__listIcon",
  "listWrapper": "TableOfContentsMobile-module-scss-module__ASJpFW__listWrapper",
  "open": "TableOfContentsMobile-module-scss-module__ASJpFW__open",
  "slide-down": "TableOfContentsMobile-module-scss-module__ASJpFW__slide-down",
  "slide-up": "TableOfContentsMobile-module-scss-module__ASJpFW__slide-up",
  "visible": "TableOfContentsMobile-module-scss-module__ASJpFW__visible",
  "wrapper": "TableOfContentsMobile-module-scss-module__ASJpFW__wrapper",
});
